import { httpClient } from 'utils/httpClient';
import { authenticationService } from 'services/Authentications/authenticationService';
import { userService } from 'services/Apis/GeneralServices/userService';
import { userInformationService } from 'services/Apis/GeneralServices/userInformationService';
import { authorizationService } from 'services/Apis/GeneralServices/authorizationService';
import { inOutService } from 'services/Apis/GeneralServices/inOutService';
import { internalTelServices } from 'services/Apis/GeneralServices/internalTelServices';
import { timesheetService } from 'services/Apis/TimesheetServices/timesheetService'
import { timesheetCompletionService } from 'services/Apis/TimesheetServices/timesheetCompletionService'
import { costCenterService } from 'services/Apis/CostCenterServices/costCenterService'
import { costCenterSubCodeService } from 'services/Apis/CostCenterServices/costCenterSubCodeService'
import { costCenterProjectOwnerService } from 'services/Apis/CostCenterServices/costCenterProjectOwnerService'
import { chatService } from 'services/Apis/GeneralServices/chatService';
import { reminderTaskService } from 'services/Apis/GeneralServices/reminderTaskService';
import { resumeService } from 'services/Apis/GeneralServices/resumeService';
import { resumeApprovalService } from 'services/Apis/GeneralServices/resumeApprovalService';
import { languageService } from 'services/Apis/GeneralServices/languagesService';
import { fileUploaderService } from 'services/Apis/GeneralServices/fileUploaderService';
import * as ermsService  from  'services/Apis/ErmsServices';
import { mediaOperationService } from 'services/Apis/GeneralServices/mediaOperationService';
import { conferenceService } from 'services/Apis/IntranetServices/ConferenceService';
import { conferenceExceptionService }  from 'services/Apis/IntranetServices/ConferenceExceptionService';
import { reportService } from 'services/Apis/ReportServices/Management/ManhourSectionsConsumptionService';
import { localStorageServices } from 'services/Apis/IntranetServices/General/localStorageServices';
import { operationService } from 'services/Apis/IntranetServices/Location/OperationService';
import { settingService } from 'services/Apis/GeneralServices/settingService'; 

import { timesheetSystemService } from 'services/Apis/TimesheetSystemService/timesheetSystemService';
import { timesheetCommonServices } from 'services/Apis/TimesheetSystemService/timesheetCommonServices';
import { timesheetManagementSystem } from 'services/Apis/TimesheetSystemService/timesheetManagementSystem';
import { timesheetSystemBulkService } from 'services/Apis/TimesheetSystemService/timesheetSystemBulkService';
import { timesheetReportingService } from 'services/Apis/TimesheetSystemService/timesheetReportingService';
import { timesheetApprovalService } from 'services/Apis/TimesheetApprovalService/timesheetApprovalService';
import { timesheetManagementService } from 'services/Apis/TimesheetServices/timesheetManagementService';
import { timesheetKardexService } from 'services/Apis/TimesheetSystemService/timesheetKardexService';
import { timesheetUsedRestService } from 'services/Apis/TimesheetSystemService/timesheetUsedRestService';
import { timesheetActivityService } from 'services/Apis/TimesheetServices/timesheetActivityService';

import { dateTimeService } from 'services/Apis/TimesheetServices/dateTimeService';
import { profileSecurityService } from 'services/Apis/IntranetServices/ProfileSecurityService';
import { categoryService } from 'services/Apis/IntranetServices/InfoBoardService/Category/CategoryService';
import { fileInfoService } from 'services/Apis/IntranetServices/InfoBoardService/FileInfo/FileInfoService';
import { fileInfoClientService } from 'services/Apis/IntranetServices/InfoBoardService/FileInfoClient/FileInfoClientService';
import { seenService } from 'services/Apis/IntranetServices/Seen/SeenService';
import userAuthorizationService from 'services/Apis/GeneralServices/userAuthorizationService'

import * as cafeService from 'services/Apis/IntranetServices/CafeServices';
import * as siteAndServiceService from 'services/Apis/TimesheetServices/SiteAndService/getDataService'
import * as manipulationService from 'services/Apis/TimesheetServices/SiteAndService/manipulationService'
import * as notificationService from 'services/Apis/IntranetServices/Notification'
import * as themeService from 'services/Apis/IntranetServices/ThemeService/generalService';
import * as newsService from 'services/Apis/IntranetServices/NewsServices/domesticNewsService';
import * as newsCategoriesService from 'services/Apis/IntranetServices/NewsServices/newsCategoriesService';
import * as questionContainerService from 'services/Apis/IntranetServices/SurveyService/questionService';
import * as answerContainerService from 'services/Apis/IntranetServices/SurveyService/answerService';
import * as optionContainerService  from 'services/Apis/IntranetServices/SurveyService/optionService';
import * as columnContainerService  from 'services/Apis/IntranetServices/SurveyService/columnService';
import * as projectService  from 'services/Apis/IntranetServices/ProjectServices/ProjectServices';

import * as chipService from 'services/Apis/IntranetServices/FacilityServices/chipService';

import * as driveService from 'services/Apis/QhseServices/DriveService';
import * as folderService from 'services/Apis/QhseServices/FolderService';
import * as fileService from 'services/Apis/QhseServices/FileService';

import * as sportClubServices from 'services/Apis/IntranetServices/SportClubService/index';

import * as aboutServices from 'services/Apis/IntranetServices/AboutService';

import { kasraService } from 'services/Apis/OutsourceServices/KasraService';

// const timesheetUrl = "http://localhost:53000/api";
// const intranetUrl = "http://localhost:10418/api";

// const ermsUrl = "http://intranet:86/Api/Erms/";
// const timesheetUrl = "http://intranet:86/Api/Timesheet/api";
//const authenticateUrl = "http://intranet:86/Api/Authentication/api";
// const intranetUrl = "http://intranet:86/Api/Intranet/api";

const authenticateUrl = "/Api/Authentication/api";
const ermsUrl = "/Api/Erms/";
const timesheetUrl = "/Api/Timesheet/api";
const intranetUrl = "/Api/Intranet/api";


function apiMainFactory(){

    const authenticationApiFactory=(
        {
            authentication: authenticationService(httpClient(authenticateUrl)),
        }
    )

    const intranetApiFactory = (
        {
            generalInformation: userService(httpClient(intranetUrl)),
            userInformation: userInformationService(httpClient(intranetUrl)),
            inOut: inOutService(httpClient(intranetUrl)),
            internalTel: internalTelServices(httpClient(intranetUrl)),
            timesheet: timesheetService(httpClient(intranetUrl)),
            timesheetCompletion: timesheetCompletionService(httpClient(intranetUrl)),
            costCenter: costCenterService(httpClient(intranetUrl)),
            costCenterSubCode: costCenterSubCodeService(httpClient(intranetUrl)),
            costCenterProjectOwnerService: costCenterProjectOwnerService(httpClient(intranetUrl)),
            chat: chatService(httpClient(intranetUrl)),
            authorization: authorizationService(httpClient(intranetUrl)),
            userAuthorization: userAuthorizationService,
            reminderTask: reminderTaskService(httpClient(intranetUrl)),
            resume: resumeService(httpClient(intranetUrl)),
            resumeApprovalService: resumeApprovalService(httpClient(intranetUrl)),            
            language: languageService(httpClient(intranetUrl)),
            fileUploader: fileUploaderService(httpClient(intranetUrl)),
            mediaOperation: mediaOperationService(httpClient(intranetUrl)),
            settingService: settingService(httpClient(intranetUrl)),
            conference: conferenceService(httpClient(intranetUrl)),
            conferenceException: conferenceExceptionService(httpClient(intranetUrl)),
            report: reportService(httpClient(intranetUrl)),
            profileSecurity: profileSecurityService(httpClient(intranetUrl)),
            infoBoardCategory: categoryService(httpClient(intranetUrl)),
            fileInfo: fileInfoService(httpClient(intranetUrl)),
            fileInfoClient: fileInfoClientService(httpClient(intranetUrl)),
            seen: seenService(httpClient(intranetUrl)),
            localStorage: localStorageServices(),
            location: operationService(httpClient(intranetUrl)),
            project: projectService.ProjectService (httpClient(intranetUrl)),
            cafeApiFactory: ({
                categoryService: cafeService.categoryService(httpClient(intranetUrl)),
                menuService: cafeService.menuService(httpClient(intranetUrl)),
                orderService: cafeService.orderService(httpClient(intranetUrl)),
            }),
            notificationFactory: ({
                mailService: notificationService.mailService(httpClient(intranetUrl)),
            }),
            themeFactory: ({
                themeService: themeService.generalService(httpClient(intranetUrl))
            }),
            newsFactory: ({
                domesticNewsService: newsService.domesticNewsService(httpClient(intranetUrl)),
                newsCategoriesService: newsCategoriesService.newsCategoriesService(httpClient(intranetUrl)),
            }),
            surveyFactory: ({
                questionService: questionContainerService.questionService(httpClient(intranetUrl)),
                answerService: answerContainerService.answerService(httpClient(intranetUrl)),
                optionService: optionContainerService.optionService(httpClient(intranetUrl)),
                columnService: columnContainerService.columnService(httpClient(intranetUrl)),
            }),
            facilityFactory: ({
                chipService: chipService.chipService(httpClient(intranetUrl))
            }),
            qhseFactory: ({
                driveService: driveService.driveService(httpClient(intranetUrl)),
                folderService: folderService.folderService(httpClient(intranetUrl)),
                fileService: fileService.fileService(httpClient(intranetUrl))
            }),
            sportClubFactory: ({
                sportClubService: sportClubServices.sportClubService(httpClient(intranetUrl)),
                sportClubExceptionService: sportClubServices.sportClubExceptionService(httpClient(intranetUrl)),
            }),
            aboutFactory: ({
                documentTypeService: aboutServices.documentTypeService(httpClient(intranetUrl)),
                documentTypeDetailService: aboutServices.documentTypeDetailService(httpClient(intranetUrl)),
            })
            // cafe: cafeService(httpClient(intranetUrl)),
        }
    )

    const timesheetFactory = (
        {
            timesheetInformation: timesheetSystemService(httpClient(timesheetUrl)),
            timesheetCommonServices: timesheetCommonServices(httpClient(timesheetUrl)),
            timesheetBulkServices: timesheetSystemBulkService(httpClient(timesheetUrl)),
            timesheetReportingServices: timesheetReportingService(httpClient(timesheetUrl)),
            timesheetManagementSystemService: timesheetManagementSystem(httpClient(timesheetUrl)),
            timesheetApprovalService: timesheetApprovalService(httpClient(timesheetUrl)),
            timesheetManagementService: timesheetManagementService(httpClient(intranetUrl)),
            dateTimeService: dateTimeService(httpClient(timesheetUrl)),
            settingService: settingService(httpClient(intranetUrl)),
            kardexServiceApiFactory: ({
                timesheetKardexService: timesheetKardexService(httpClient(timesheetUrl)),
                timesheetUsedRestService: timesheetUsedRestService(httpClient(timesheetUrl)),
            }),
            siteAndServiceApiFactory: ({
                getPersonnelTypes: siteAndServiceService.getDataService(httpClient(timesheetUrl)),
                manipulationService: manipulationService.manipulationService(httpClient(timesheetUrl))
            }),
            domesticNewApiFactory: ({
                
            }),
            activityApiFactory: ({
                timesheetActivityService: timesheetActivityService(httpClient(timesheetUrl))
            })
        }
    )

    const ermsServices=(
        {
          coordinatorService:ermsService.coordinatorService(httpClient(ermsUrl)),
            headSectionService:ermsService.headSectionService(httpClient(ermsUrl)),
            ermsService:ermsService.ermsService(httpClient(ermsUrl)),
            pmdbService:ermsService.pmdbService(httpClient(ermsUrl)),
            responsibleService:ermsService.responsibleService(httpClient(ermsUrl)),
            directionManagerService:ermsService.directionManagerService(httpClient(ermsUrl)),
            reportService:ermsService.reportService(httpClient(ermsUrl)),

          cartableService:ermsService.cartableService(httpClient(ermsUrl)),
          ermsService:ermsService.ermsService(httpClient(ermsUrl)),
          atomicService:ermsService.atomicService(httpClient(ermsUrl)),
          userService:ermsService.userService(httpClient(ermsUrl)),
          homaService:ermsService.homaService(httpClient(ermsUrl))
        })


        const outsourceServices={
            kasraService:kasraService(httpClient(intranetUrl))
        };

    return {
        authenticationApiFactory,
        intranetApiFactory,
        timesheetFactory,
        ermsServices,
        outsourceServices
        }
}



export const apiFactory=apiMainFactory();










// const apiMainFactory = (function () {
//     const authenticateUrlHttp = httpClient(authenticateUrl);
//     const intranetHttp = httpClient(intranetUrl);
//     const ermsHttp = httpClient(ermsUrl);

//     const authenticationApi = authenticationApiFactory(authenticateUrlHttp);
//     const intranetApi = intranetApiFactory(intranetHttp);
//     const ermsApi = ermsApiFactory(ermsHttp);

//     function authenticationApiFactory(http) {
//         return {
//             authentication: authenticationService(http),
//         };
//     }

//     function intranetApiFactory(http) {
//         return {
//             generalInformation: userService(http),
//             inOut: inOutService(http),
//             internalTel: internalTelServices(http),
//             timesheet: timesheetService(http),
//             costCenter: costCenterService(http),
//             chat: chatService(http),
//             authorization: authorizationService(http)
//         };
//     }

//     function ermsApiFactory(http) {
//         return {
            
//         };
//     }

//     return {
//         authenticationApiFactory: authenticationApi,
//         intranetApiFactory: intranetApi
//     }

// });

// export const apiFactory = apiMainFactory();




